// import { ROOT_URL } from '../../../config/dev.env'
import axios from 'axios' // 引入axios
import { Indicator } from 'mint-ui';
// import { getCookie, alert } from './mUtils'
// import qs from 'qs' //引入qs

// var _xhr = new XMLHttpRequest();
// var allow_cors = "withCredentials" in _xhr; // 查看浏览器是否支持cookie跨域方式

export const fetch = (method, url, data, option) => {
  var options = option || {
    baseURL: ROOT_URL,
    withCredentials: false, // default
    headers: {
     // 'Content-Type': 'application/x-www-form-urlencoded',
     // 'Content-Type': 'application/json',
      'Content-Type': 'application/json;charset=UTF-8'

    },
    validateStatus: function (status) {
      return status >= 200 && status < 600;// 默认
    }
  }
  // console.log('arguments',arguments[2]);
  if (method == 'GET') {
      options.method = 'GET';
      options.url = url;
      if (arguments[2]) {
          options.params = data;
      }
    var request = axios.request(options); // api 原生的返回
  } else if (method == 'POST') {
    // data = JSON.stringify(data);
    var request = axios.post(url, data, options)
  }

  Indicator.open({
    text: '加载中...',
    spinnerType: 'snake'
  });

  var reqiestObj = request.then((res) => {
    Indicator.close();
    // 后台返回数据

    var data = res.data;

    // 后台返回状态

    if (typeof data === 'string') {
      data = JSON.parse(data);
      var code = data.code;
    } else {
      var code = data.code;
    }

    // 后台响应成功
    if (code == 100) {
      return Promise.resolve(data);
    } else {
        // 后台响应失败   可能有各种状态码
      return Promise.resolve(data);
    }
  })

  return reqiestObj;
}



// WEBPACK FOOTER //
// ./src/common/js/fetch.js